import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { ConvexReactClient } from "convex/react";
import { LanguageProvider } from "./lib/i18n";
import { initSentry } from "./lib/sentry";
import "./index.css";
import App from "./App";

initSentry();

const convex = new ConvexReactClient(
  import.meta.env.VITE_CONVEX_URL as string
);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ConvexAuthProvider client={convex}>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </ConvexAuthProvider>
  </StrictMode>
);
